import { motion } from 'framer-motion';
import React from 'react';

const SideMenu = ({ isTabletView, isOpen, setIsOpen, children }) => {
  const animation = isTabletView && {
    open: {
      x: 0,
      width: '16rem',
      transition: {
        damping: 40,
        duration: 0.1,
      },
    },
    closed: {
      x: -256,
      width: 256,
      transition: {
        damping: 40,
        duration: 0.1,
      },
    },
  };

  return (
    <>
      <div onClick={() => setIsOpen(false)} className={`background-locked xl:hidden ${isOpen ? 'block' : 'hidden'} `} />
      <motion.div
        variants={animation}
        initial={{ x: isTabletView ? -256 : 0 }}
        transition={{
          duration: 0.1,
        }}
        animate={isOpen ? 'open' : 'closed'}
        className="sidebar"
      >
        {children}
      </motion.div>
    </>
  );
};

export default SideMenu;
